import { format } from "date-fns";
import { ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import { EyeIcon } from "../../ui/icons/eyeIcon";
import { SortIcon } from "../../ui/icons/sort";
import { TrashIcon } from "../../ui/icons/trashIcon";
import { Spinner } from "../../ui/molecoles/spinner";
import { ConfirmModal } from "../../ui/organisms/confirmModal";
import { Dropdown } from "../../ui/organisms/dropdown";
import { deleteReport, findAllReport, setFilterSort, setFilterSortBy, setOpenDeleteConfirmModal, setOpenNewReportModal, setReportId, setSelectedTab } from "./slice";

export function ReportList() {
    const dispatch = useAppDispatch()
    const navigation = useNavigate()

    const reportState = useAppSelector(state => state.report)

    const [isDelete, setIsDelete] = useState<string | undefined>()
    const [sort, setSort] = useState<number>(reportState.findAllFilters.sort)

    let reportList: ReactNode[] = []

    useEffect(() => {
        dispatch(findAllReport(reportState.findAllFilters))
    }, [])

    useEffect(() => {
        if (reportState.createReportStatus === "successfully") {
            dispatch(setOpenNewReportModal(false))
            dispatch(findAllReport(reportState.findAllFilters))
        } else if (reportState.createReportStatus === "failed")
            dispatch(setOpenNewReportModal(false))
    }, [reportState.createReportStatus])

    useEffect(() => {
        if (reportState.deleteReportStatus === "successfully" || reportState.deleteReportStatus === "failed") {
            dispatch(findAllReport(reportState.findAllFilters))
        }
    }, [reportState.deleteReportStatus])

    if (reportState.findAllStatus === "loading" || reportState.deleteReportStatus === "loading") {
        return (
            <div className={"flex justify-center items-center flex-grow"}>
                <Spinner />
            </div>
        )
    }

    if (reportState.findAllStatus === "successfully" &&
        reportState.findAllResponse !== undefined &&
        reportState.findAllResponse.data !== undefined &&
        reportState.findAllResponse.data.length > 0) {
        reportState.findAllResponse.data.forEach((item) => {
            reportList.push(
                <tr
                    className="bg-white h-[56px] border-b-[1px] border-b-neutral-100"
                    key={item.id}
                >
                    <td
                        className="py-4 px-4 text-text-sm cursor-pointer font-semibold text-neutral-850 hover:text-pas-500 hover:font-bold"
                        onClick={() => {
                            dispatch(setReportId(item.id))
                            dispatch(setSelectedTab(0))
                            navigation("/report/" + item.id)
                        }}
                    >
                        {item.flight_info.flight.ident_iata}
                    </td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{item.flight_info.flight.departure.airport.name}</td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{item.flight_info.flight.arrival.airport.name}
                    </td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{format(item.flight_info.flight.departure.flight_gate_times.scheduled_out, "yyyy-MM-dd") === "0001-01-01" ? "-" : format(item.flight_info.flight.departure.flight_gate_times.scheduled_out, "dd-MM-yyyy")}
                    </td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">
                        {format(item.createdAt, "dd-MM-yyyy")}
                    </td>
                    <td className="h-[56px] py-4 px-2 flex justify-end flex-row items-center">
                        <Dropdown
                            items={[
                                {
                                    label: "Detail",
                                    icon: <EyeIcon size={24} color={""} />,
                                    onClick: () => {
                                        dispatch(setReportId(item.id))
                                        dispatch(setSelectedTab(0))
                                        navigation("/report/" + item.id)
                                    }
                                },
                                {
                                    label: "Delete",
                                    icon: <TrashIcon size={24} color={""} />,
                                    onClick: () => {
                                        setIsDelete(item.id)
                                        dispatch(setOpenDeleteConfirmModal(true))
                                    }
                                }
                            ]}
                        />
                    </td>
                </tr>
            )
        })
    }

    return (
        <div className="w-full flex flex-col gap-4 rounded-tr-xl rounded-tl-xl rounded-b-lg overflow-auto">
            <div>
                <table className="w-full mb-3">
                    <thead className="h-[56px] bg-neutral-100 font-semibold text-neutral-500 text-text-xs">
                        <tr>
                            <th className="text-left">
                                <div className="flex py-4 px-4 gap-1">
                                    FLIGHT IDENT
                                </div>
                            </th>
                            <th className="text-left">
                                <div className="flex py-4 px-2 gap-1">
                                    DEPARTURE AIRPORT
                                </div>
                            </th>
                            <th className="text-left">
                                <div className="flex py-4 px-2 gap-1">
                                    ARRIVAL AIRPORT
                                </div>
                            </th>
                            <th className="text-left">
                                <div className="flex flex-row items-center gap-[2px]">
                                    <div className="flex items-center py-4 px-2 gap-1">
                                        FLIGHT DATE
                                    </div>
                                    <div
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            e.preventDefault()
                                            // order && setOrder(order)
                                        }}
                                        className="cursor-pointer hover:opacity-70"
                                    >
                                        <SortIcon
                                            onClick={() => {
                                                if (reportState.findAllFilters.sort === 0 || reportState.findAllFilters.sort === 1) {
                                                    setSort(-1)
                                                    dispatch(setFilterSort(-1))
                                                } else if (reportState.findAllFilters.sort === -1) {
                                                    setSort(1)
                                                    dispatch(setFilterSort(1))
                                                }
                                                dispatch(setFilterSortBy("flight_info.flight.departure.flight_gate_times.scheduled_out"))
                                                dispatch(findAllReport({
                                                    page: reportState.findAllFilters.page,
                                                    pageSize: reportState.findAllFilters.pageSize,
                                                    sort: sort,
                                                    sortBy: "flight_info.flight.departure.flight_gate_times.scheduled_out",
                                                    name: reportState.findAllFilters.name,
                                                    surname: reportState.findAllFilters.surname,
                                                    flightIdent: reportState.findAllFilters.flightIdent,
                                                    departureAirport: reportState.findAllFilters.departureAirport,
                                                    arrivalAirport: reportState.findAllFilters.arrivalAirport,
                                                    fromDate: reportState.findAllFilters.fromDate
                                                }))
                                            }}
                                            size={0}
                                            color={""}
                                        />
                                    </div>
                                </div>
                            </th>
                            <th className="text-left">
                                <div className="flex flex-row items-center gap-[2px]">
                                    <div className="flex py-4 px-2 gap-1">
                                        CREATION DATE
                                    </div>
                                    <div
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            e.preventDefault()
                                            // order && setOrder(order)
                                        }}
                                        className="cursor-pointer hover:opacity-70"
                                    >
                                        <SortIcon
                                            onClick={() => {
                                                if (reportState.findAllFilters.sort === 0 || reportState.findAllFilters.sort === 1) {
                                                    setSort(-1)
                                                    dispatch(setFilterSort(-1))
                                                } else if (reportState.findAllFilters.sort === -1) {
                                                    setSort(1)
                                                    dispatch(setFilterSort(1))
                                                }
                                                dispatch(setFilterSortBy("created_at"))
                                                dispatch(findAllReport({
                                                    page: reportState.findAllFilters.page,
                                                    pageSize: reportState.findAllFilters.pageSize,
                                                    sort: sort,
                                                    sortBy: "created_at",
                                                    name: reportState.findAllFilters.name,
                                                    surname: reportState.findAllFilters.surname,
                                                    flightIdent: reportState.findAllFilters.flightIdent,
                                                    departureAirport: reportState.findAllFilters.departureAirport,
                                                    arrivalAirport: reportState.findAllFilters.arrivalAirport,
                                                    fromDate: reportState.findAllFilters.fromDate
                                                }))
                                            }}
                                            size={0}
                                            color={""}
                                        />
                                    </div>
                                </div>
                            </th>
                            <th className="text-left">
                                <div className="flex py-4 px-2 gap-1" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            reportState.findAllResponse?.paginationData.total === 0 ?
                                <tr className="bg-white h-[56px] border-b-[1px] border-b-neutral-100">
                                    <td className="py-4 px-4 text-text-sm font-semibold text-neutral-850">Nessun report</td>
                                </tr>
                                :
                                reportList
                        }
                    </tbody>
                </table>
            </div>
            <ConfirmModal
                open={reportState.openDeleteConfirmModal}
                handleClose={() => dispatch(setOpenDeleteConfirmModal(false))}
                title={"Delete report"}
                description={"Are you sure you want to delete this report?"}
                labelDeny={"Cancel"}
                labelConfirm={"Delete"}
                actionConfirm={() => {
                    isDelete && dispatch(deleteReport(isDelete))
                    dispatch(setOpenDeleteConfirmModal(false))
                }}
            />
        </div>
    )
}